__turbopack_context__.v({
  "active": "ltwoaW_active",
  "content": "ltwoaW_content",
  "tab": "ltwoaW_tab" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "typography": "ltwoaW_typography",
});
